export interface ContentToken {
  id: string;
  text: string;
  children?: ContentToken[] | null;
}

export type RawContentToken = { id?: string; text?: string; children?: RawContentToken[] };

export const normalizeContentTokens = (raw: RawContentToken[]): ContentToken[] => {
  return raw
    .map((token): ContentToken | null => {
      if (typeof token.id !== 'string' || !token.id) {
        return null;
      }
      const children = Array.isArray(token.children) ? normalizeContentTokens(token.children) : [];
      return {
        id: token.id,
        text: typeof token.text === 'string' ? token.text : '',
        children: children.length ? children : null,
      };
    })
    .filter((token): token is ContentToken => token !== null);
};
